export const categories = [
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '最新热门电影资源，高清画质磁力链接一键获取',
    color: 'primary',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '海量国内外电视剧，追剧必备磁力搜索',
    color: 'accent',
  },
  {
    slug: 'music',
    name: '音乐',
    icon: 'ri-music-2-line',
    description: '无损音乐专辑合集，高品质音频资源下载',
    color: 'secondary',
  },
  {
    slug: 'software',
    name: '软件',
    icon: 'ri-terminal-box-line',
    description: '实用软件工具合集，办公设计编程全覆盖',
    color: 'primary',
  },
  {
    slug: 'document',
    name: '文档',
    icon: 'ri-file-text-line',
    description: '学习资料、电子书、教程文档资源汇总',
    color: 'accent',
  },
  {
    slug: 'game',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: '热门游戏资源，涵盖单机网络各类大作',
    color: 'secondary',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目资源，轻松娱乐一网打尽',
    color: 'primary',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '热门动漫番剧资源，日漫国漫应有尽有',
    color: 'accent',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-800', badge: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-800', badge: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800', badge: 'bg-secondary-500' },
};